var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.fileUrl)?_c('a',{attrs:{"href":_vm.fileUrl,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.$t('File')))]):_c('p',[_vm._v(" "+_vm._s(_vm.$t('Not found'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }